var angular = require('angular')
var langCs = require('./i18n/cs.js').cs
var langEn = require('./i18n/en.js').en
require('./components/uniform/uniform.component.js')
require('angular-file-upload')
var logErrorToBackendService = require('aem-libs-angularjs/src/services/log-error-to-backend.service').logErrorToBackendService
var isUserOnMobileCheck = require('../../services/isMobile')
var isUserClientCheck = require('../../services/isUserClient')
var createGroupTree = require('../../services/createGroupTree')
var assignThemeFieldsClasses = require('aem-libs-uniforms/src/themes/assignFieldsClasses')
var queryString = require('query-string')
var assingBusinessNamesValues = require('aem-libs-uniforms-angularjs/src/services/assignBusinessNamesValues')

angular.module('UniformDetailCmp', ['uniformCmp', 'angularFileUpload'])
  .factory('logErrorToBackendService', logErrorToBackendService)
  .factory('visibilityDependencyDataservice', require('../../services/visibility-dependency.dataservice'))
  .factory('$exceptionHandler', ['$log', 'logErrorToBackendService', function ($log, logErrorToBackendService) {
    return function logErrorToBackendExceptionHandler (exception, cause) {
      $log.error(exception, cause)
      logErrorToBackendService.error(exception, cause)
    }
  }])
  .component('uniformDetail', {
    template: require('./uniform-detail.component.tpl.html'),
    controller: UniformDetailCtrl,
    controllerAs: 'vm',
    bindings: {
      formId: '<',
      showTitle: '<',
      hideDate: '<',
      userTrackingParams: '<',
      submitFormElementId: '<',
      onSubmitted: '&',
      initValueByBusinessName: '<',
      themeFieldsClasses: '<'
    }
  })

require('./service/uniforms.service.js')

UniformDetailCtrl.$inject = ['appLoader', 'i18n', 'uniformsService',
  'visibilityDependencyDataservice', '$window']

function UniformDetailCtrl (appLoader, i18n, uniformsService,
  visibilityDependencyDataservice, $window) {
  var vm = this

  vm.$onInit = function () {
    i18n.appendLangFile('cs', langCs)
    i18n.appendLangFile('en', langEn)
    vm.error = false
    vm.fullData = null
    vm.onUniformSubmitted = function (params) { vm.onSubmitted({ params: params }) }
    vm.queryStringBusinessNamesValues = queryString.parse($window.location.search)

    getData()
  }

  function getData () {
    uniformsService.getUniformDescription(vm.formId)
      .then(function (response) {
        var fullData = response.data
        if (vm.themeFieldsClasses) {
          fullData.formFields = assignThemeFieldsClasses(fullData.formFields, vm.themeFieldsClasses)
        }
        if (vm.queryStringBusinessNamesValues) {
          fullData.formFields = assingBusinessNamesValues(fullData.formFields, vm.queryStringBusinessNamesValues)
        }
        visibilityDependencyDataservice.init(fullData.formFields)
        fullData.formFields = createGroupTree(fullData.formFields)
        setDefaultValueByBusinessName('is-mobile', isUserOnMobileCheck().toString(), fullData.formFields)
        if (vm.initValueByBusinessName) { // detection of inlet aem-feedback-form-smiles using business name of radio buttons with smiles
          if (vm.initValueByBusinessName === 'co-si-myslite-first-form') {
            setDefaultValueByBusinessName('url', window.location.href, fullData.formFields)
            setDefaultValueByBusinessName('has-cluid', isUserClientCheck().toString(), fullData.formFields)
          } else { // it's second-form of aem-feedback-form-smiles
            setDefaultValueByBusinessName(vm.initValueByBusinessName.businessName, vm.initValueByBusinessName.initValue, fullData.formFields)
          }
        }
        vm.fullData = fullData
      })
      .catch(function () {
        vm.error = true
      })
      .finally(function () {
        appLoader.hide()
      })
  }

  function setDefaultValueByBusinessName (businessName, initValue, formFields) {
    for (var i = 0, l = formFields.length; i < l; i++) {
      if (formFields[i].businessName === businessName) {
        formFields[i]['defaultValueI18N'] = initValue
      }
    }
  }
}
